/*jshint esversion: 6 */
import React, { Component } from 'react';
import '../css/style.css';
import '../css/utils.css'
//import IntroLogo from './IntroLogo.js';
//import introText from './texts/intro.txt';

class OnlyTextFloatRight extends Component {
  constructor(props){
    super(props);
    this.state = {};
  }
    render() {
        console.log('OnlyText props', this.props);
        var header = this.props.header;
        var content = this.props.content;
        var templateHeader = "right_" + this.props.templateHeader;
        // var isSub = this.props.isSub;
        // var isParent = this.props.isParent;
        // var columnClass = " column_item " + "column_item_" + templateHeader + " column_item_isSub_" + isSub + " "+ " column_item_isParent_" + isParent + " ";
        var el = document.createElement( 'div' );
        el.innerHTML = content;



        <div className="text_header_container " >
        <div className="text_header " >
          {header}
        </div>
        <div className="text_header_underline "></div>
      </div>


        if(header || content){
          return (
            <div className={templateHeader+"_column"} >
              {header?
                <div className={"text_header_container " + templateHeader+"_header_container"} >
                  <div className={"text_header " + templateHeader+"_header"} >
                    {header}
                  <div className={"text_header_underline " + templateHeader+"_header_underline"}></div>
                  </div>
                </div>
              :''}
              {content?
                <div className={templateHeader+"_content"} >
                  
                  <div ref={(nodeElement) => {(nodeElement)? nodeElement.appendChild(el):''}}/>
                </div>
              :''}
            </div>
          );
        }
        else{
          return('');
        }
      }

}

export default OnlyTextFloatRight;


// WEBPACK FOOTER //
// ./src/Templates/OnlyTextFloatRight.js